<template>
  <section id="content">
    <v-card class="auth-card mx-auto" :loading="loading">
      <v-img :src="require('@/assets/logos/VAFURSLOGO_TRANSPARENT.png')"></v-img>
      <v-form @submit.prevent="login">
        <v-container>
          <v-row>
            <v-text-field
              v-model="email"
              type="text"
              label="Email"
              :disabled="loading"
              required
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              required
              @keyup.enter.native="login"
              :disabled="loading"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              v-model="confirmPassword"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              label="Confirm Password"
              required
              :disabled="loading"
              @keyup.enter.native="login"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-row>
          <v-row >
            <p class="error--text" v-if="error">{{error}}</p>
          </v-row>
          <v-row>
            <v-btn
              tile
              color="primary"
              class="ml-auto"
              :disabled="loading"
              @click="setPassword"
            >Set Password</v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </section>
</template>

<script>
  import firebase from "firebase/app";

  export default {
    name: 'AuthForm',
    data () {
      return {
          email: '',
          password: '',
          confirmPassword: '',
          showPassword: false,
          error: undefined,
          auth: false,
          loading: false
      }
    },
    methods: {
      async setPassword () {
        this.error = undefined;

        if (this.password !== this.confirmPassword) {
            this.error = "Passwords do not match";
            return;
        }

        this.loading = true;

        try {
          if(!this.auth && firebase.auth().currentUser == null) {
            await firebase.auth().signInWithEmailLink(this.email, window.location.href);
            window.localStorage.removeItem('emailForSignIn');
            this.auth = true;
          }

          await firebase.auth().currentUser.updatePassword(this.password);
          this.$router.push( {path: '/' });
        } catch (err) {
            this.error = err.message;
        }
        this.loading = false;
      }
    },
    mounted() {
      const email = window.localStorage.getItem('emailForSignIn');
      if(email)
          this.email = email;
    }
  }
</script>
<style>
  .auth-card {
    margin-top: calc(50vh - 300px);
    width: 95% !important;
    max-width: 400px !important;
    padding: 1em 3em;
    min-height: 650px;
  }
</style>
